var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow_up",
    "data-name": "Arrow up",
    transform: "translate(313 -6008)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1666",
    "data-name": "Rectangle 1666",
    width: 20,
    height: 20,
    transform: "translate(-313 6008)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-arrow_2_",
    "data-name": "right-arrow (2)",
    d: "M17.107,12.171a.62.62,0,0,0-.855.9l4.756,4.511H8.62a.62.62,0,1,0,0,1.24H20.989l-4.736,4.511a.62.62,0,1,0,.855.9l5.409-5.152a1.239,1.239,0,0,0-.011-1.764Z",
    transform: "translate(-321.001 6033.88) rotate(-90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowup);
export default __webpack_public_path__ + "static/media/Arrow up.49cdb7c2b0b50a102501902966ed2612.svg";
export { ForwardRef as ReactComponent };